import React, { Component } from 'react';
// import '../../App.css';
import { connect } from 'react-redux';
import { BrowserRouter as Router,Route,Link} from 'react-router-dom';
import { withRouter } from 'react-router';
import LevelList from './editTiers/levelList.js';
import WistiaVideo from './Videos.js';
import Footer from './Footer.js';
import TopNav from '../includes/TopNav';
import {Helmet} from 'react-helmet';

const styles = {
    localH1: { 
        fontSize: '36px',
    },
    localH2: { 
        fontSize: '28px',
    },
    onlyParagraph: { 
        fontSize: '20px',
        lineHeight: '26px',
    },
    instructionList: { 
        paddingTop: '10px',
        listStyleType: 'disc',
    },
    instructionListItem: { 
        paddingTop: '10px',
    },
    introText: { 
        fontSize: '24px',
        lineHeight: '26px',
        marginBottom: '10px',
    }
}
class Guarantee extends Component{

    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div>
                <Helmet>
                    <title>Essay Editing Service Guarantee | Edit My Paper</title>
                    <meta name="description" content="At Edit My Paper we pride ourselves on our dedication to helping students and professionals with their English essay editing needs to improve their written work"></meta>
                    <meta name="keywords" content="Edit,My,Paper,Editing,Examples,University,College,Students"></meta>
                    <link rel="canonical" href="https://editmypaper.ca/guarantee" />
                </Helmet>
                <TopNav />
                <section className="steps top_section">
                    <div className="steps-container">
                        <center>
                            <h1 style={styles.localH1}>Edit My Paper's 100% Guarantee</h1>
                            <h2 style={styles.localH2}>Remember, we do more than just proofread - we edit your work until it reads perfectly!</h2>
                        </center>
                        <div style={styles.introText}>
                            At Edit My Paper we pride ourselves on our dedication to helping students and professionals with their English, Spanish, and French essay editing and proofreading needs to improve their written work. We guarantee that your paper will be returned to you within 30 minutes of the Time Limit / Turnaround time you have selected, or your money back. As well, if you are not completely satisfied with the service your editor has provided, we will work with you to remedy the situation quickly.
                        </div>
                        <div style={styles.onlyParagraph}>
                            The Edit My Paper 100% Guarantee:
                            <ul style={styles.instructionList}>
                                <li style={styles.instructionListItem}>We know that your work may be time sensitive and we’re here to help. In the unlikely event that you are unsatisfied with the service your Gold level editor has provided, we will immediately remedy the situation - you can start by initiating a Live Chat with us online. Please note that we only: edit and correct your spelling, grammar, punctuation, word choice, make flow improvements (including run-on sentences), improve your overall writing style, and correct any incorrectly used English words/phrases. We do not fact check, create content from scratch, check for plagiarized work, paraphrase, or edit citations/bibliography/works cited (we only correct citations if you discuss this with us prior to submitting your work). Editors will also provide comments to help you make any necessary improvements outside of the aspects we cover. We also offer Additional Options, which can be selected once you Login and view our Upload page. If there are any issues with your edited work, please do not hesitate to contact us via email immediately and be sure to leave a callback telephone number and the exact time your essay is due. Issues are dealt with promptly between 8 AM to Midnight EST. You have six hours from the time your paper is completed to initiate a claim by emailing us at <a href="mailto:info@editmypaper.ca">info@editmypaper.ca</a> - this is to ensure we can remedy the situation immediately, before your paper is due.</li>
                                <li style={styles.instructionListItem}>If there is a substantial problem with your edited paper, we will initiate a review of it and may choose to immediately send it to be re-edited by another editor. We will also initiate contact with the original editor to see if there were any issues on their side. If it is clear that the editor did not perform a sufficient edit throughout the entire document, he/she may not be paid fully and the client may receive a re-edit or, at our discretion, a full or partial refund depending on the area and extent of the complaint.</li>
                                <li style={styles.instructionListItem}>Edit My Paper strives to provide efficient, helpful, and constructive essay or report editing to assist our clients in their studies or business and takes seriously any mal-effort on the part of the editor. Please note that results may vary depending on the quality of paper submitted. We do not re-write your paper for you, however, our editors do their best to make your work read like a university level essay should! If you believe your paper will require substantial corrections, you should select the ESL or Extra Comments addon to give your essay a further boost. Our editors provide comments and essay writing tips to make you aware of any critical errors in your paper.</li>
                                {
                                    /** video and edit-tiers medals to come here */
                                }
                            </ul>
                        </div>
                        <WistiaVideo></WistiaVideo>
                    </div>
                </section>
                <Footer></Footer>
            </div>
        )
    }
}

export default connect(
  )(Guarantee);
  


// WEBPACK FOOTER //
// ./src/components/pages/Guarantee.js